import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "u-tooltip"
};
const _hoisted_2 = {
    key: 1,
    class: "u-tooltip"
};
const _hoisted_3 = {
    key: 2,
    class: "u-tooltip"
};
const _hoisted_4 = {
    key: 3,
    class: "u-tooltip"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'UTooltip',
    props: {
        type: {
            type: String,
            default: "question"
        },
        tooltip: {
            type: String,
            default: ""
        },
        position: {
            type: String,
            default: "top"
        }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (__props.position == 'left')
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_1, [
                        _createVNode(_component_UIcon, {
                            "icon-size": "12px",
                            icon: "question"
                        })
                    ])), [
                        [
                            _directive_tooltip,
                            __props.tooltip,
                            void 0,
                            { left: true }
                        ]
                    ])
                    : _createCommentVNode("", true),
                (__props.position == 'top')
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _createVNode(_component_UIcon, {
                            "icon-size": "12px",
                            icon: "question"
                        })
                    ])), [
                        [
                            _directive_tooltip,
                            __props.tooltip,
                            void 0,
                            { top: true }
                        ]
                    ])
                    : _createCommentVNode("", true),
                (__props.position == 'button')
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _createVNode(_component_UIcon, {
                            "icon-size": "12px",
                            icon: "question"
                        })
                    ])), [
                        [
                            _directive_tooltip,
                            __props.tooltip,
                            void 0,
                            { bottom: true }
                        ]
                    ])
                    : _createCommentVNode("", true),
                (__props.position == 'right')
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createVNode(_component_UIcon, {
                            "icon-size": "12px",
                            icon: "question"
                        })
                    ])), [
                        [_directive_tooltip, __props.tooltip]
                    ])
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
